  // for use in api calls
  export const getAccessToken = () => {
    const accessToken = sessionStorage.getItem('access_token');
    return accessToken;
  };
